// SurveyComponent.js
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import "./SurveyComponent.css";
import GameContentProvider from "./providers/GameContentProvider";

const SurveyComponent = ({ gameId, onSubmit }) => {
  const { t } = useTranslation();
  const [experienceRating, setExperienceRating] = useState(5);
  const [difficultyRating, setDifficulty] = useState("");
  const [hadProblem, setHadProblem] = useState("");
  const [problemDetails, setProblemDetails] = useState("");
  const [mapRecommendations, setMapRecommendations] = useState("");
  const [mapComment, setMapComment] = useState("");
  const [generalFeedback, setGeneralFeedback] = useState("");
  const [feedbackComment, setFeedbackComment] = useState("");
  const [learnedAbout, setLearnedAbout] = useState("");
  const [learnedAboutOther, setLearnedAboutOther] = useState("");
  const [likedLeastMostRiddle, setLikedLeastMostRiddle] = useState("");

  const handleSubmit = async () => {
    let token = localStorage.getItem('token');
    if (!token) {
                    token = localStorage.getItem('guest_token');
    }
    const feedbackData = {
      gameId,
      token,
      experienceRating,
      difficultyRating,
      hadProblem,
      problemDetails: hadProblem === t("Yes") ? problemDetails : "",
      mapRecommendations,
      mapComment: mapRecommendations === t("Other") ? mapComment : "",
      generalFeedback,
      feedbackComment: generalFeedback === t("Yes") ? feedbackComment : "",
      learnedAbout,
      learnedAboutOther: learnedAbout === t("Other") ? learnedAboutOther : "",
      likedLeastMostRiddle,
    };
    console.log(feedbackData);
    try {
       const gameContentProvider = new GameContentProvider();

      const result = await gameContentProvider.submitSurvey(feedbackData);
      console.log("Survey submitted successfully:", result);
      onSubmit(); // close the survey
    } catch (err) {
      console.error("Failed to submit survey:", err);
    }
    //onSubmit(feedbackData);
  };

  const close = () => {
    onSubmit();
  };

  return (
    <div className="survey-container">
      <h2>{t("Game Feedback Survey")}</h2>

      {/* Question 1 */}
      <div className="survey-question">
        <label>{t("1. How would you rate your game experience?")}</label>
        <input
          type="range"
          min="1"
          max="10"
          value={experienceRating}
          onChange={(e) => setExperienceRating(e.target.value)}
          className="experience-slider"
        />
        <span className="slider-value" style={{ color: `hsl(${experienceRating * 12}, 100%, 50%)` }}>
          {experienceRating}
        </span>
      </div>

      {/* Question 2 */}
      <div className="survey-question">
        <label>{t("2. How would you rate the difficulty of the challenges?")}</label>
        {[t("Too easy"), t("Some are easy, some hard"), t("Good"), t("Too complicated")].map((option) => (
          <div className="div-survey" key={option}>
            <input
              type="radio"
              name="difficulty"
              value={option}
              onChange={(e) => setDifficulty(e.target.value)}
            />
            <label>{option}</label>
          </div>
        ))}
      </div>

      {/* Question 3 */}
      <div className="survey-question">
        <label>{t("3. Did you have a problem with any of the steps?")}</label>
        {[t("Yes"), t("No")].map((option) => (
          <div className="div-survey" key={option}>
            <input
              type="radio"
              name="hadProblem"
              value={option}
              onChange={(e) => setHadProblem(e.target.value)}
            />
            <label>{option}</label>
          </div>
        ))}
        {hadProblem === t("Yes") && (
          <textarea
            placeholder={t("Explain what")}
            value={problemDetails}
            onChange={(e) => setProblemDetails(e.target.value)}
          ></textarea>
        )}
      </div>

      {/* Question 4 */}
      <div className="survey-question">
        <label>{t("4. What do you think about the map recommendations?")}</label>
        {[t("I am not interested"), t("Add more"), t("Very useful"), t("Other")].map((option) => (
          <div className="div-survey" key={option}>
            <input
              type="radio"
              name="mapRecommendations"
              value={option}
              onChange={(e) => setMapRecommendations(e.target.value)}
            />
            <label>{option}</label>
          </div>
        ))}
        {mapRecommendations === t("Other") && (
          <textarea
            placeholder={t("Comment")}
            value={mapComment}
            onChange={(e) => setMapComment(e.target.value)}
          ></textarea>
        )}
      </div>

      {/* Question 5 */}
      <div className="survey-question">
        <label>{t("5. Would you like to give any recommendation or feedback for City Hunters?")}</label>
        {[t("Yes"), t("No")].map((option) => (
          <div className="div-survey" key={option}>
            <input
              type="radio"
              name="generalFeedback"
              value={option}
              onChange={(e) => setGeneralFeedback(e.target.value)}
            />
            <label>{option}</label>
          </div>
        ))}
        {generalFeedback === t("Yes") && (
          <textarea
            placeholder={t("Your feedback")}
            value={feedbackComment}
            onChange={(e) => setFeedbackComment(e.target.value)}
          ></textarea>
        )}
      </div>

      {/* Question 6 */}
      <div className="survey-question">
        <label>{t("6. How did you learn about City Hunters?")}</label>
        {[t("From a friend"), t("From video ad"), t("Other")].map((option) => (
          <div className="div-survey" key={option}>
            <input
              type="radio"
              name="learnedAbout"
              value={option}
              onChange={(e) => setLearnedAbout(e.target.value)}
            />
            <label>{option}</label>
          </div>
        ))}
        {learnedAbout === t("Other") && (
          <textarea
            placeholder={t("How did you learn?")}
            value={learnedAboutOther}
            onChange={(e) => setLearnedAboutOther(e.target.value)}
          ></textarea>
        )}
      </div>

      {/* Question 7 */}
      <div className="survey-question">
        <label>{t("7. What step/riddle you liked the most and which the least?")}</label>
        <textarea
          placeholder={t("Your answer")}
          value={likedLeastMostRiddle}
          onChange={(e) => setLikedLeastMostRiddle(e.target.value)}
        ></textarea>
      </div>

      {/* Submit Button */}
      <div className="div-survey">
        <button className="submit-button" onClick={handleSubmit}>{t("Submit Feedback")}</button>
        <button className="submit-button" onClick={close}>{t("Close")}</button>
      </div>
    </div>
  );
};

export default SurveyComponent;
